import { ApiError } from 'src/error/customError/ApiError';
export class NotFoundError extends ApiError {}
